module.exports = __webpack_public_path__ + "static/media/sv-counter-text-bg.f4819ab7.png";